export var en = {
  meta: {
    title: "UgrzejMnie — Fuel, heating, AC & solar PV in Poland",
    description: "UgrzejMnie — order fuel (propane, pellet, pea coal, gas), boiler and heat pump service, air conditioning or solar PV. Local technicians respond, you choose the best offer.",
    ogTitle: "UgrzejMnie — Fuel, service, AC & PV",
    ogDescription: "Order fuel, heating service, air conditioning or solar PV in minutes. Local pros respond — you choose the offer.",
  },
  nav: {
    skip: "Skip to content",
    homeAria: "UgrzejMnie — home",
    aria: "Main navigation",
    home: "Home",
    how: "How it works",
    app: "App",
    offer: "What you order",
    service: "Service",
    payments: "Payments",
    trust: "Security",
    provider: "For providers",
    fuelProviders: "For Fuel Suppliers",
    technicians: "For Technicians",
    more: "More",
    download: "Download app",
    game: "Game",
    menu: "Menu",
  },
  lang: {
    label: "Select language",
  },
  trustBar: {
    label: "Flexible billing",
    text: "Online payments via Stripe, deferred Klarna (30 days) or cash on delivery — depending on the provider's offer.",
  },
  hero: {
    headline: "Fuel & boiler service — when you need it.",
    lead: "Order propane, pellet, gas, pea coal, heating service, air conditioning or solar PV in minutes. Local technicians respond — you choose the offer.",
    downloadAndroid: "Get it on Android",
    downloadIos: "Download for iPhone (coming soon)",
    securityNote: "Order securely in the app — confirming an order requires your explicit action.",
    forProviders: "For providers",
    playGame: "Play Ugrzej Osiedle",
  },
  how: {
    heading: "How it works",
    sub: "Three steps — from request to delivery or service at your home.",
    step1: {
      title: "Place an order",
      desc: "Describe your need — fuel, heating service, air conditioning or solar PV. Provide your location and preferred date.",
    },
    step2: {
      title: "Technician offers",
      desc: "Local providers and technicians respond in the app. Compare prices and dates.",
    },
    step3: {
      title: "Delivery / service",
      desc: "Choose an offer — fuel comes to you, the technician arrives at the agreed time.",
    },
    cluster: {
      kicker: "Fuel with neighbours",
      title: "Group drop — shared delivery",
      desc: "Ordering pellet, coal or gas? Open a group drop in the app and send the link to neighbours. Combine quantities on one route — often cheaper than separate trips.",
      cta: "Open in the app",
    },
    slots: {
      kicker: "Route Opportunities",
      title: "Route slots & cheaper travel",
      desc: "Fuel suppliers and technicians publish their planned trips. If you live along their corridor, you can book an order and benefit from lower prices or zero travel fees.",
      cta: "Check opportunities",
    },
  },
  app: {
    heading: "App in action",
    sub: "Customer, provider and desktop — this is what UgrzejMnie looks like inside.",
    slide1: "Quick order",
    slide2: "Service catalogue",
    slide3: "Offers & quotes",
    slide4: "Provider panel",
    slide5: "Your specialisations",
    slide6: "Job quotation",
    slide7: "Orders desktop",
    slide8: "Quick quote",
    prev: "Previous screen",
    next: "Next screen",
    dots: "Select screen",
    dot: "Screen",
  },
  offer: {
    heading: "What you order",
    sub: "One app for fuel, heating, air conditioning and solar PV — a technician when you need one.",
    propan: {
      title: "Propane",
      desc: "Tank refill — delivery to your address, without calling distributors.",
    },
    pellet: {
      title: "Pellet & pea coal",
      desc: "Seasonal solid fuel orders — compare offers from local providers.",
    },
    heatpump: {
      title: "Heat pump",
      desc: "Inspection, service and repair — technicians experienced with your heating system.",
    },
    solidBoiler: {
      title: "Solid fuel boiler",
      desc: "Cleaning, combustion adjustment, part replacement — on-site service.",
    },
    gas: {
      title: "Gas & LPG",
      desc: "Delivery and refilling of gas tanks, service of gas boiler rooms and LPG installations.",
    },
    electric: {
      title: "Electric heating",
      desc: "Inspections, repairs and replacement of components in home electric heating systems.",
    },
    ac: {
      title: "Air conditioning",
      desc: "Service, cleaning and installation of AC units — local F-Gas certified technicians.",
    },
    pv: {
      title: "Solar PV",
      desc: "PV system service plus installation or expansion — quotes from local installers.",
    },
  },
  reminders: {
    heading: "Don't miss your service",
    sub: "Save your heating installation and UgrzejMnie will remind you of the service date before the season starts.",
    step1: {
      title: "Add your boiler room",
      desc: "Save the address, heating type, boiler or heat pump model and installation parameters in one place.",
    },
    step2: {
      title: "Set a service date",
      desc: "Choose the date of the next inspection. The system will calculate the time remaining to the technician's visit.",
    },
    step3: {
      title: "Receive a reminder",
      desc: "Before the date you'll get a notification and can easily book service with a trusted local technician.",
    },
  },
  payments: {
    heading: "Convenient and secure payments for fuel and service",
    sub: "At ugrzejmnie.pl we connect you directly with local heating fuel suppliers and technicians. Providers set the accepted payment methods for their offers, so you can choose the solution that best fits your needs.",
    klarna: {
      title: "Buy now, pay later with Klarna",
      desc: "Selected providers offer flexible Klarna deferred payments. Order pellet, pea coal, wood or gas, and you'll see the repayment terms (including any instalments) in Klarna Checkout before confirming.",
      note: "Available with providers who offer Klarna payments",
    },
    stripe: {
      title: "Fast and secure Stripe payments",
      desc: "Pay instantly by card (Visa, Mastercard), or via other payment methods available in Stripe Checkout. Stripe guarantees a high level of security (PCI-DSS) and transaction confirmation.",
      note: "Available with providers who support online payments",
    },
    cash: {
      title: "Pay at delivery (cash / COD)",
      desc: "Prefer traditional? Many local providers allow cash settlement on delivery or service completion — at the base offer price, with 0 PLN platform service fee.",
      note: "Payment details are shown on each individual offer",
    },
    promo: {
      title: "Order fuel for winter without an immediate budget hit",
      desc: "Look for providers on ugrzejmnie.pl that offer Klarna payments — receive your fuel as agreed, and settle with Klarna according to the terms shown in Checkout.",
      days: "30",
      daysUnit: "days",
    },
  },
  trust: {
    heading: "Trust & security",
    sub: "Your data and payments are protected at every stage — from placing an order to settling with the provider.",
    encryption: {
      title: "Encrypted personal data",
      desc: "Sensitive data, such as your national ID number for fuel deliveries, is encrypted and passed only to the selected provider.",
    },
    certified: {
      title: "Certified payments",
      desc: "Online payments are processed by Stripe with the highest PCI-DSS Level 1 security standard. Your card data is never stored on our servers.",
    },
    marketplace: {
      title: "Local provider marketplace",
      desc: "UgrzejMnie connects you with trusted technicians and providers in your area. The contract and fulfilment remain between you and the chosen professional.",
    },
    reviews: {
      title: "Authentic, verified reviews",
      desc: "No fake reviews. Only customers whose order was completed and confirmed with a digital signature can leave feedback.",
    },
    notifications: {
      title: "Order status notifications",
      desc: "You receive notifications about new offers, status changes and upcoming service so you never miss anything.",
    },
  },
  provider: {
    heading: "Become a UgrzejMnie provider",
    sub: "Reach customers who need fuel, heating service, air conditioning or solar PV in your area. Manage offers, payments and orders from your phone and desktop — in one ecosystem.",
    benefitMixedRoute: {
      title: "Mixed Routes A+B & Daily Runs",
      desc: "Combine platform orders with your depot's own direct customers on a single truck. Add private orders with a nominal technical fee of just 0.5% (min. 3 PLN). The system automatically optimizes stop order from your yard and tracks vehicle load capacity.",
    },
    benefitDriverManifest: {
      title: "Driver without apps, e-Waybills & offline",
      desc: "No installation or login required. The driver scans 1 QR code in the morning: access Google Maps navigation, cash-on-delivery tracking, digital delivery signatures with PESEL/ID for excise tax exemption, and on-the-road order additions even without mobile reception.",
    },
    benefitRouteSlots: {
      title: "Route slots & orders on the way",
      desc: "Planning a trip with spare capacity or service availability? Publish your route — the app will attract orders along your transport corridor.",
    },
    benefitReputation: {
      title: "Verified reputation system",
      desc: "Reviews can only be given by customers after a completed order confirmed with a digital signature. Build your brand without risk of fake competitor reviews.",
    },
    benefit1: {
      title: "Flexible payments and transparent commissions",
      desc: "You decide whether to accept cash, online payments (Stripe, card) or Klarna. Platform commissions are visible on every offer, and you receive funds directly from the customer.",
    },
    benefit2: {
      title: "Orders on WhatsApp",
      desc: "You don't have to constantly monitor the app. Enable WhatsApp notifications and new orders in your area will go straight to your phone. Submit an offer with one click via a dedicated, secure link — no login required.",
    },
    benefit3: {
      title: "Desktop app",
      desc: "Working at a desk? Download the Windows, macOS or Linux version and manage orders from your computer. Full account management stays in the mobile app, so sensitive settings are safe.",
    },
    benefit4: {
      title: "Set your service range",
      desc: "You decide how far you travel. Set a radius from 10 to 200 km — changes sync automatically between the mobile app and the desktop.",
    },
    benefit5: {
      title: "Subscription and billing in one place",
      desc: "Manage your subscription, payout methods and commission history from the Profile tab. Everything transparent and accessible right after logging in.",
    },
    benefit6: {
      title: "Group drops — fuller routes",
      desc: "Customers combine fuel deliveries into one group drop. You get several stops on a shared route and quote them together instead of driving for single orders.",
    },
    promo: {
      kicker: "Promotion for technicians",
      title: "First service job is free",
      desc: "No job — no fee. You can see requests and quote without a subscription. From the second completed job (heat pumps, boilers, heating, AC, PV) a category fee applies. Fuel deliveries stay unchanged.",
    },
    pricing: {
      kicker: "Pricing for providers",
      title: "Sample platform rates",
      disclaimer:
        "This is a sample price list. Rates may be set individually after contact.",
      commissionsTitle: "Commissions on fuel deliveries",
      subsTitle: "Service subscriptions (30 days)",
      loading: "Loading price list…",
      error: "Could not load the price list.",
      cta: "Ask for an individual offer",
      cat: {
        heat_pumps: "Heat pump service",
        boilers: "Boiler and stove service",
        installations: "Heating installation service",
        ac: "Air conditioning (service & install)",
        pv: "Solar PV and energy storage",
      },
    },
    mobileApp: "Mobile app",
    apiBadge: "For ERP / TMS / WMS systems",
    apiTitle: "Seamless API & Webhooks Integration",
    apiDesc: "Running your own ERP, TMS, or warehouse management software (e.g. Subiekt, Optima, SAP)? Receive quote requests, submit offers, and send digital proof-of-delivery signatures 100% automatically via our secure REST API and webhooks.",
    apiTag1: "Automated Orders",
    apiTag2: "Real-time Webhooks",
    apiTag3: "API Keys & HMAC",
    apiCta: "Open Integrator Portal (API Docs)",
    docsTitle: "Partner Information Guides",
    docsDesc: "Download detailed PDF guides on our collaboration model, billing and platform features:",
    pdfServiceTitle: "For Technicians & Installers",
    pdfFuelTitle: "For Heating Fuel Suppliers",
    pdfServiceText: "Guide for Technicians & HVAC Installers (PDF)",
    pdfFuelText: "Guide for Fuel Providers & Coal Yards (PDF)",
    gatewayFuelTitle: "Fuel Suppliers & Coal Yards",
    gatewayFuelDesc: "0% commission on own direct orders, mixed routes, 1 Driver QR Code, e-WZ, Excise Shield, and fleet plans.",
    gatewayTechTitle: "HVAC Installers & Technicians",
    gatewayTechDesc: "Heat pumps (F-Gas), heating boilers, AC, free trial (1st job free).",
    desktopTitle: "Desktop application",
    desktopNote: "Account management, specializations and subscriptions stay in the mobile app — keeping sensitive settings secure on your phone. Desktop contains everything needed for comfortable desk work: job notifications and quick quote submission.",
    formTitle: "Start selling with us",
    formSubtitle: "Fill in the short form, we will contact you",
    fieldName: "Full name / Company name",
    fieldNamePlaceholder: "e.g. John Smith / Gas-Build Ltd.",
    fieldEmail: "E-mail",
    fieldEmailPlaceholder: "your@email.com",
    fieldPhone: "Phone number",
    fieldPhonePlaceholder: "600 700 800",
    fieldCity: "City and operating area",
    fieldCityPlaceholder: "e.g. Warsaw and surroundings up to 30 km",
    fieldServices: "Offered services / products",
    servicePropan: "Propane",
    servicePellet: "Pellet / Pea coal",
    serviceBoiler: "Boiler / Heat pump service",
    serviceAc: "Air conditioning",
    servicePv: "Photovoltaics",
    fieldNotes: "Additional notes (optional)",
    fieldNotesPlaceholder: "Tell us a few words about your company...",
    consent: "I consent to the processing of my personal data in accordance with the",
    consentPrivacy: "Privacy Policy",
    consentPurpose: "for handling the inquiry and commercial contact.",
    captchaLabel: "Anti-spam verification",
    captchaLoading: "Loading question...",
    captchaRefresh: "Refresh question",
    captchaPlaceholder: "Enter answer",
    submit: "Send inquiry",
    sending: "Sending...",
    instructWin: "<strong>Instructions (Windows):</strong> Download and run the <code>.exe</code> installer. The program will install automatically and add a desktop shortcut.",
    instructMac: "<strong>Instructions (macOS):</strong> Download the <code>.dmg</code> file (choose Apple Silicon for new Macs with M1/M2/M3/M4 chips, or Intel for older models). Open it and drag the app to the Applications folder.",
    instructLinux: "<strong>Instructions (Linux):</strong> We recommend the <code>.deb</code> package (icon and system menu). If you use the <code>AppImage</code> version, after downloading mark the file as executable (<code>chmod +x</code>) and choose 'Allow running as program' in your file manager.",
    loadingVersions: "Loading versions…",
    refreshVersions: "Refresh version list",
    errorNoAssets: "No installation files found in the latest release.",
    errorLoad: "Unable to fetch the version list. Please try again later.",
    currentVersion: "Current version:",
    draft: "(draft)",
    seeDownloads: "See download section",
    warningWin: "The app is currently under review in the Microsoft Store. If Windows displays a warning before running, click <em>\"More info\"</em> and then <em>\"Run anyway\"</em>. We assure you the program is completely safe.",
  },
  b2bFuel: {
    trustBar: "0% commission on direct orders · Fleet subscriptions · 1 Driver QR Manifest · Digital e-WZ with signature & Excise ID.",
    badge: "Logistics Ecosystem for Fuel Suppliers & Coal Yards",
    headline: "More orders along the route and zero paper delivery notes.",
    lead: "Combine your own direct customers with marketplace orders from UgrzejMnie on one truck. Give the driver 1 daily QR code, collect digital e-WZ delivery signatures with excise IDs, and operate 100% offline.",
    btnRegister: "Register your yard",
    btnPricing: "View pricing",
    btnPdf: "Download PDF (2 p. A4)",
    featuresHeadline: "How UgrzejMnie optimizes your fuel yard?",
    featuresLead: "Built specifically for Polish coal and fuel yards, tanker drivers, and tax office audits.",
    cardMixedRouteTitle: "Mixed Route A+B",
    cardMixedRouteDesc: "Have regular direct customers? Enter their orders (Stream B) with 0% commission and pick up marketplace drops (Stream A) along the way. You only pay a success fee when we bring you new customers.",
    cardMixedRouteBadge: "Shared payload & TSP",
    cardQrTitle: "Daily Route & QR Manifest",
    cardQrDesc: "Driver scans 1 daily QR code in the morning. Stop order is auto-optimized from your yard with 1-click Google Maps navigation.",
    cardQrBadge: "No app installation required",
    cardEwzTitle: "Digital e-WZ & Excise Shield",
    cardEwzDesc: "Mandatory PESEL/ID number, excise exemption purpose statement, digital customer signature on phone, GPS timestamps, and 1-click CSV export for tax authorities.",
    cardEwzBadge: "Excise Protection",
    cardOfflineTitle: "100% Offline & Roadside Drops",
    cardOfflineDesc: "No LTE signal at rural customer property? Entire manifest, POD receipts and signatures work offline. Driver can also log spontaneous drops on the go.",
    cardOfflineBadge: "Outbox Sync",
    cardAdjustTitle: "Auto Volume Adjustment",
    cardAdjustDesc: "For bulk tanker deliveries: if tank capacity is less than ordered, system immediately refunds the difference to the card (Stripe Connect). Driver collects surplus in cash at fixed offer rate.",
    cardAdjustBadge: "Zero disputes",
    cardApiTitle: "Open Integrator API",
    cardApiDesc: "Connect UgrzejMnie directly to your yard's ERP/TMS (Subiekt, Symfonia, Comarch). Orders and quotes stream via secure machine-to-machine webhooks.",
    cardApiBadge: "REST + Webhooks",
    puescBadge: "Available — PUESC integration",
    puescHeadline: "SENT and e-DD straight from the route — automatically to MF",
    puescLead: "The PUESC module is live in the provider app and desktop. SENT (transport) and e-DD (excise delivery) declarations are generated from the completed route and signed with a qualified signature — no manual re-entry into e-Tax Office.",
    puescSoon: "Available",
    puescSentTitle: "SENT — Transport Declarations",
    puescSentDesc: "Automatic transport declarations of excise goods to the Electronic Transport Supervision System. Route, vehicle and driver data are pulled straight from the Day Course — no duplicate entries in e-Tax Office.",
    puescEddTitle: "e-DD — Electronic Delivery Documents",
    puescEddDesc: "Electronic delivery documents for excise fuel, signed with a qualified XAdES certificate. Generated automatically from e-WZ upon customer confirmation — with PESEL number, GPS stamp and excise statement.",
    puescCtaTitle: "Turn on SENT and e-DD at your yard",
    puescCtaDesc: "The PUESC module is included in Pro and Enterprise. Choose a fleet plan or write to us — we will roll it out on your routes.",
    puescCtaBtn: "See fleet plans",
    lpgSentBadge: "SENT for LPG / autogas stations",
    lpgSentHeadline: "One route — three SENT closing paths with the station",
    lpgSentLead: "LPG autogas deliveries to fuel stations need SENT-100 and SENT-103 with dispenser readings. UgrzejMnie distinguishes own stations (same NIP) from external ones and supports the RecipientKey (KR-…) — without logging the station into the supplier’s PUESC account.",
    lpgPathOwnKicker: "1 · Own NIP",
    lpgPathOwnTitle: "Own station / same company",
    lpgPathOwnDesc: "After unload the driver records dispenser readings. The system closes SENT-103 in PUESC for the supplier (STANDARD) — no KR key.",
    lpgPathKrKicker: "2 · External NIP + KR",
    lpgPathKrTitle: "Franchise / partner station with RecipientKey",
    lpgPathKrDesc: "The station registers KR-… once (email portal or desktop catalog). After delivery you close SENT-103 on its behalf: official SENT number + RecipientKey + readings.",
    lpgPathExtKicker: "3 · External NIP, no KR",
    lpgPathExtTitle: "Station closes in its own PUESC",
    lpgPathExtDesc: "Email with reference, then official SENT number and dispenser readings. The station closes SENT-103 on its account; the operator confirms in the desktop (CONFIRMED_EXTERNALLY).",
    lpgSentBullet1: "Two station emails: after registration (reference) and after PUESC assigns the official SENT number.",
    lpgSentBullet2: "Station portal (magic link) to submit RecipientKey once — no account in your app.",
    lpgSentBullet3: "Dispenser meter readings from the route; corrections possible before external confirmation.",
    lpgSentDocBtn: "LPG station SENT brief (HTML / print PDF)",
    lpgSentContactBtn: "Talk about station rollout",
    lpgSentLegal: "As with the whole PUESC module: filings and SISC rights remain the supplier’s responsibility. The tool does not replace the station’s PUESC account or tax decisions.",
    pricingKicker: "Fuel Provider Pricing",
    pricingHeadline: "Commission only on new orders + Fleet Subscription",
    pricingLead: "0% commission on your direct loyal customers (Stream B). Pay success commission only when we bring you a new marketplace buyer.",
    streamATitle: "Marketplace Orders (Stream A)",
    streamADesc: "For orders acquired from UgrzejMnie apps from homeowners and businesses in your area.",
    streamARate: "0.5% – 1.0%",
    streamANote: "Success commission charged only on fulfilled orders",
    streamBTitle: "Direct Yard Orders (Stream B)",
    streamBDesc: "For your direct customers from yard, phone or Excel imports. 0% sales commission.",
    streamBRate: "0 PLN (0% commission)",
    streamBNote: "0 PLN commission on your own fuel sales and loyal customer base",
    monthlyInvoiceTitle: "Single monthly consolidated B2B invoice",
    monthlyInvoiceDesc: "Marketplace commissions (Stream A) and optional fleet subscriptions (Plan Pro / Enterprise via B2B invoice) are settled monthly with 14-day payment terms. Direct yard orders (Stream B) are billed at 0 PLN (0%).",
    zeroHiddenFees: "0 PLN hidden fees",
    puescLoading: "Loading plan pricing…",
    puescError: "Plan pricing unavailable — contact us.",
    puescKicker: "Fleet Subscriptions & Yard Tools",
    puescPlansHeadline: "Choose a tier tailored to your fleet size",
    puescPlansLead: "Basic plan with 0 PLN fixed fees (only commission on new Stream A customers) or Pro / Enterprise tiers with PUESC module (SENT and e-DD). Subscription prices are promotional until end of 2026.",
    puescNote: "Net subscription prices. Promotional offer until end of 2026. Basic plan always 0 PLN/month with 0% commission on your own direct customers (Stream B).",
    pdfTitle: "Download Fuel Provider Guide (PDF)",
    pdfDesc: "Complete 2-page A4 summary: automated PUESC / SENT / e-DD reporting, fleet & e-TOLL management, mixed routes A+B (0% commission), QR Manifest workflow, and digital e-WZ excise inspection protocols.",
    formHeadline: "Need tailored fleet onboarding?",
    formLead: "You can get started immediately by downloading the mobile app above. If you operate a large yard or vehicle fleet and need onboarding assistance — leave your details below.",
    formSubmit: "Submit onboarding inquiry",
  },
  b2bTech: {
    trustBar: "Free Trial — 1st completed job 100% free · Digital service report · Jobs in your county.",
    badge: "B2B Zone for HVAC Installers & Technicians",
    headline: "More jobs in your county and guaranteed settlements.",
    lead: "Receive direct quote requests from homeowners for heat pump inspections (F-Gas), boiler maintenance, AC installation and PV systems. Try risk-free — first completed job with 0% commission and 0 PLN subscription!",
    btnJoin: "Download app & join",
    btnPricing: "Pricing & Trial",
    btnPdf: "Download PDF",
    featuresHeadline: "What jobs await you in UgrzejMnie?",
    featuresLead: "Connecting you with homeowners needing service strictly within your chosen working radius.",
    pricingKicker: "Pricing for Technicians",
    pricingHeadline: "Free Trial and flexible county subscriptions",
    pricingLead: "Transparent terms without hidden fees. Pay only when you want to receive jobs from a chosen region.",
    trialTitle: "Welcome Package (Free First Job)",
    trialDesc: "For every newly registered HVAC installer and technician.",
    trialRate: "0 PLN",
    trialNote: "First completed job 100% free of commission and subscription",
    subsTitle: "Service Subscription (30 days)",
    subsDesc: "Activated after completing the free trial job for the selected category.",
    subsRate: "39 – 49 PLN / 30 days",
    subsNote: "0% commission on service value with active subscription",
    pdfTitle: "Download Technician Guide (PDF)",
    pdfDesc: "Discover collaboration details: county job assignment rules, digital service receipt templates, and profitability calculations.",
    formHeadline: "Need assistance onboarding your business?",
    formLead: "You can register yourself directly in the mobile app. If you have questions or represent a larger installer team — leave your contact details below.",
    formSubmit: "Submit contact inquiry",
  },
  faq: {
    heading: "Frequently asked questions",
    sub: "A quick guide to how UgrzejMnie works — before you download the app.",
    q1: "What is UgrzejMnie?",
    a1: "An app that connects you with local fuel providers and technicians for heating, air conditioning and solar PV. Place a request, receive offers and choose the one that suits you.",
    q2: "What services do you cover?",
    a2: "In the app you can order fuel and service for solid fuel boilers (pellet, pea coal), LPG and propane tanks, gas boiler rooms, heat pumps and electric heating, as well as air conditioning service and installation and solar PV systems.",
    q3: "Will the app remind me of an upcoming service?",
    a3: "Yes. You can save your heating installation with the next service date. UgrzejMnie will send you an advance notification so you can book the right technician in time.",
    q4: "Who delivers fuel and carries out the service?",
    a4: "Independent providers and technicians from your area. UgrzejMnie is a marketplace — we connect the parties, but the contract and fulfilment are agreed directly between you and the chosen professional.",
    q5: "What payment methods are available on ugrzejmnie.pl?",
    a5: "Available methods depend on the offer. You can pay the driver in <strong>cash (COD)</strong> at the base offer price (PLN 0 platform fee) or choose a <strong>protected online payment</strong> (card, BLIK, P24 or Klarna) with the Safe Payment Package — Stripe authorisation, cashless handling and priority complaint support. The service fee is shown before you confirm and is retained by the Operator; the supplier receives the offer base price.",
    q6: "How do I check which payments a provider accepts?",
    a6: "The accepted payment methods are always clearly shown on the specific offer card when placing an order or requesting a quote.",
    q7: "How does Klarna deferred payment work for fuel?",
    a7: "If your chosen provider supports Klarna payments, you can order fuel with the 'Buy now, pay later' option (Klarna terms are shown in Checkout). You receive the delivery as agreed with the provider, and settle with Klarna according to its terms.",
    q8: "Are online payments on ugrzejmnie.pl secure?",
    a8: "Yes. Digital payments are processed by Stripe's certified payment gateway, which holds the highest international PCI-DSS Level 1 security standard. No card data is stored on ugrzejmnie.pl.",
    q9: "Is there an iPhone app?",
    a9: "The customer and provider apps are currently available on Android. The iOS version is in development and will be available soon.",
    q10: "Does it work in my area?",
    a10: "Offers come from local providers. The more technicians there are in your region, the faster you'll receive responses. Download the app and check availability near you.",
    q11: "Why might a national ID be required for fuel delivery?",
    a11: "For fuel deliveries (liquid, solid, LPG, cylinders) the Platform may require a national ID number for the provider's documentation. The number is passed only to the assigned provider and is not used for marketing — details are in the Privacy policy.",
    q12: "I'm a technician — how do I get started?",
    a12: "Download the provider mobile app, complete your profile and specialisations. Technicians start without a subscription: the first completed service job (heat pumps, boilers, heating, AC, PV) is free — from the second, a category fee applies. You can also invite regular customers with a link or QR code. For desk work you can add the desktop app (Windows, macOS, Linux) — details are in the For providers section.",
    q13: "What is the provider desktop app for?",
    a13: "The desktop is a handy addition at a desk: order notifications and quick quotes. Full account, specialisation and subscription management stays in the mobile app — so sensitive settings remain under control on your phone, and only the essential minimum is on the computer.",
    q14: "Why are orders placed through the app instead of a web form?",
    a14: "The mobile app serves as a security layer for the entire marketplace. It protects providers and customers from fake orders, enables instant push notifications (for quotes, delivery schedules, and order approvals), and builds a verified trust reputation — which a simple web form cannot provide.",
    q15: "What is a fuel group drop?",
    a15: "It's a shared delivery with neighbours. You open a group drop in the app, send a link or code, and neighbours join with their own quantity of the same fuel and packaging. The provider drives one route — often cheaper than separate trips.",
  },
  footer: {
    tagline: "Fuel & boiler service — when you need it.",
    facebook: "Follow us on Facebook",
    toTop: "Back to top",
    contact: "Contact",
    navigation: "Navigation",
    navAria: "Quick links",
    legal: "Information",
    legalAria: "Legal information",
    privacy: "Privacy policy",
    terms: "Terms of service",
    apiDocs: "Integrator Portal (API)",
    pdfService: "Guide for Technicians (PDF)",
    pdfFuel: "Guide for Fuel Providers (PDF)",
    pdfLpgSent: "LPG stations SENT brief",
    forProviders: "For Fuel Suppliers",
    forTechnicians: "For Technicians",
    copyright: "© 2026 UgrzejMnie · HelpMeNow Prosta S.A. All rights reserved.",
    companyName: "HelpMeNow Prosta S.A.",
    address: "ul. Wspólna 2, 96-330 Mrozy, Poland",
    registry: "KRS 0001127133 · NIP 8381887256 · REGON 529645405",
    phone: "+48 690 355 556",
  },
  cookie: {
    text: "Our website uses cookies necessary for its proper operation, including remembering preferences (e.g. the provider invitation code). More information can be found in our",
    privacyLink: "Privacy policy",
    accept: "Got it",
  },
  // SENTBeton — dla-betonu.html (standalone page, keys prefixed sb.)
  sb: {
    meta: {
      title: "SENTBeton — ready-mix plant readiness for Poland's SENT register",
      description: "Early adopter programme for concrete plants: ready e-WZ delivery notes compliant with EN 206 (download a sample PDF), preparation for the SENT register (draft bill UD437), driver link and API. No web panel — before the rules take effect.",
      ogTitle: "SENTBeton — readiness / early adopters",
      ogDescription: "We are building a list of plants that want to be ready for SENT on ready-mix concrete. e-WZ, mixer trucks, API — starting now, without waiting for the legislation.",
    },
    nav: {
      aria: "Navigation",
      ewz: "e-WZ",
      how: "How it works",
      products: "Products",
      faq: "FAQ",
      early: "Early adopters",
      blog: "Blog & Guides",
      contact: "Contact",
    },
    hero: {
      kicker: "Readiness programme · early adopters · draft bill UD437",
      ready: "<strong>Readiness</strong> Ready-mix concrete is not yet covered by SENT under the law in force. We are building a list of plants that want their e-WZ, processes and integrations ready — before the rules (draft bill UD437) take effect.",
      h1: "Get your batching plant ready before SENT covers concrete",
      lead: "SENTBeton is a toolkit for ready-mix producers and mixer truck fleets: a dispatcher console, a driver app, a fulfilment link and an API. No web panel for daily work. You join as an early adopter — we deploy the processes and documents now, and adapt SENT messaging once the final wording of the act stabilises.",
      ctaJoin: "Join the early adopters",
      ctaEwz: "Download a sample e-WZ (PDF)",
      ctaFlow: "See a single delivery run",
      ctaNote: "EN 206-compliant e-WZ, dispatcher console and driver app — already available, try them today. Fulfilment link and API — arranged at onboarding. No promised date for the legal obligation.",
    },
    ewz: {
      h2: "e-WZ is ready — a complete EN 206 document",
      lead: "Our digital e-WZ replaces the paper delivery ticket from the batching plant. The document is generated before the mixer truck leaves, carries the full set of mix parameters, and is ready to be shown en route — even before the recipient signs.",
      i1: "<strong>Mix design:</strong> strength class and exposure classes, consistence, maximum aggregate size D<sub>max</sub>, cement type and strength class, chemical admixtures, w/c ratio",
      i2: "<strong>Certification:</strong> National Factory Production Control (ZKP) certificate number, Construction Mark B, reference to PN-EN 206+A2:2021-08 and PN-B-06265",
      i3: "<strong>Technological timestamps:</strong> batching time at the plant plus recorded arrival and unloading times — proof of keeping within the 90–120 min window",
      i4: "<strong>Roadside inspection:</strong> a document to show ITD/KAS inspectors or the site manager even before discharge — with the SENT reference number and QR code once the registration duty applies",
      i5: "<strong>Added water:</strong> a legal clause recording the quantity and the authorising person, with a responsible signature",
      i6: "<strong>PUESC outage:</strong> when the register is down — the transport runs on a WZ document and the report is resubmitted once the gateway is back",
      dlTag: "Documents available",
      dlText: "This is what documents generated by SENTBeton look like: an e-WZ with the mix design and timestamps before departure, and a POD after the recipient signs — here with a recorded water addition and the legal clause.",
      btnEwz: "Open the sample e-WZ (PDF)",
      btnPod: "Open the sample POD (PDF)",
      btnCsv: "Download the CSV template (bulk import)",
      dlNote: "Illustrative documents — sample data in Polish. In the CSV only columns marked <strong>*</strong> are required (customer, phone, site address); the rest — including <code>lat</code>/<code>lng</code> and technological timestamps — are optional.",
    },
    flow: {
      h2: "What a single run looks like",
      lead: "A typical day at the plant: the dispatcher plans the dispatches, the mixer truck heads to the site, the recipient confirms the delivery, and the system closes the documents and the PUESC communication.",
      s1t: "Plan and WZ issue",
      s1d: "On the dispatcher console: mix design / concrete class, volume (m³), WZ number, vehicle, driver, site address and the time window.",
      s2t: "Run start",
      s2d: "The driver gets the job in the app or a one-off link (SMS / WhatsApp / e-mail from the sentbeton.pl domain). No browser account needed.",
      s3t: "SENT report",
      s3d: "At departure the system prepares and sends the transport report (incl. SENT-100) linked to the WZ. For mixer trucks — no OBU/ZSL locator required.",
      s4t: "On site: e-WZ",
      s4d: "The recipient signs the confirmation on a phone. A digital record remains (POD / e-WZ) with the time and run data.",
      s5t: "Closure and outages",
      s5d: "After delivery the SENT report is closed. When the PUESC gateway is down — outage mode based on the WZ, resubmitted once connectivity returns (substantive responsibility stays with the producer).",
    },
    products: {
      h2: "What SENTBeton consists of",
      lead: "One platform, several touchpoints — so dispatch, the driver and the plant's ERP don't have to live in a browser.",
      avail: "Available",
      p1t: "Dispatcher console",
      p1d: "SENTBeton Dispatcher desktop app (Windows, macOS, Linux).",
      p1i1: "issuing e-WZ and planning runs",
      p1i2: "SENT statuses and report history",
      p1i3: "roadside inspection / outage mode",
      p1i4: "PUESC settings and mixer fleet",
      p2t: "Driver app",
      p2d: "SENTBeton Driver for Android (iOS in the queue).",
      p2i1: "run list and navigation to the site",
      p2i2: "recipient signature on the spot",
      p2i3: "offline work with later synchronisation",
      p2i4: "roadside-inspection screen / emergency WZ",
      p3t: "Fulfilment link",
      p3d: "A one-off address from SMS, WhatsApp or e-mail — no installation.",
      p3i1: "WZ details and site address",
      p3i2: "arrival confirmation",
      p3i3: "digital signature on site",
      p3i4: "links from the sentbeton.pl domain",
      p4tag: "For plant IT",
      p4t: "Integrator API",
      p4d: "An open API for connecting the ERP / batching dispatch system.",
      p4i1: "creating orders / dispatches from outside",
      p4i2: "status and document webhooks",
      p4i3: "WZ attachments, signatures, SENT metadata",
      p4i4: "the same backend as the console and the app",
    },
    apiBox: {
      h3: "Integration without a “web panel”",
      p: "Daily work runs through the console, the driver app, links and the API. The sentbeton.pl site is for information and contact — not for dispatcher sign-in. API documentation and a test account are arranged at onboarding (<a href=\"mailto:kontakt@sentbeton.pl?subject=SENTBeton%20API\">kontakt@sentbeton.pl</a>).",
    },
    sent: {
      h2: "SENT for concrete — preparation under draft bill UD437",
      lead: "After the veto of the earlier amendment, the government returned to the topic with draft bill UD437 (incl. concrete in mixer trucks, with no OBU/ZSL locator in the assumptions). It is still a draft — not binding law. Below are the areas we address in the product so the plant can enter the obligation calmly rather than “overnight”.",
      th1: "Topic",
      th2: "Context (draft)",
      th3: "In SENTBeton tools",
      r1c1: "Report",
      r1c2: "Ready-mix concrete runs by mixer trucks",
      r1c3: "Prepared processes and submission linked to the WZ",
      r2c1: "GPS / OBU",
      r2c2: "Assumed exemption for mixer trucks",
      r2c3: "Configuration with no locator requirement",
      r3c1: "Measure",
      r3c2: "Volume (m³), mass by density",
      r3c3: "m³ in the e-WZ and in report data",
      r4c1: "PUESC outage",
      r4c2: "Emergency procedure / WZ document",
      r4c3: "Outage mode + resubmission once the gateway is back",
      r5c1: "B2C recipient",
      r5c2: "Private customer in the draft's assumptions",
      r5c3: "Confirmation on the sender / plant side",
      note: "SENTBeton provides intermediary software. The producer is responsible for the accuracy of the data and the tax consequences — see the <a href=\"/regulamin\">Terms of Service</a> for details. The wording of UD437 may change during the legislative process; we update the product to the final text.",
    },
    faq: {
      h2: "Frequently asked questions",
      lead: "Answers for dispatchers, batching-plant managers and documentation staff.",
      q1: "Is the e-WZ already available, or is it “coming soon”?",
      a1: "It is available. We generate the e-WZ document today — before the mixer truck leaves — as an A4 PDF with the full mix design, technological timestamps and the SENT number. You can <a href=\"/static/landing/assets/sentbeton/przykladowa-e-wz.pdf\" target=\"_blank\" rel=\"noopener\">download a sample e-WZ</a> and a <a href=\"/static/landing/assets/sentbeton/przykladowy-pod.pdf\" target=\"_blank\" rel=\"noopener\">sample POD after signing</a> and compare them with the paper delivery ticket from your plant.",
      q2: "How do I enter dozens of orders at once? Is there a CSV import?",
      a2: "Yes — the dispatcher bulk-imports orders from a CSV file (semicolon separated, UTF-8). Only three columns marked with an asterisk are required: <code>klient*</code>, <code>telefon*</code> and <code>adres_budowy*</code>. The rest — the EN 206 mix design (D<sub>max</sub>, cement, admixtures, w/c, ZKP), technological timestamps, GPS coordinates (<code>lat</code>/<code>lng</code> — we geocode the address when you leave them blank) or a recorded water addition — are optional. <a href=\"/static/landing/assets/sentbeton/wzor_dostaw_betonu.csv\" target=\"_blank\" rel=\"noopener\">Download the CSV template</a> with three sample deliveries: complete, standard and minimal.",
      q3: "Does the e-WZ meet the requirements of EN 206?",
      a3: "Yes — we designed the document around clause 7.3 of PN-EN 206+A2:2021-08 (delivery document for ready-mixed concrete) and the national PN-B-06265. The e-WZ includes, among others, the strength and exposure classes, consistence, maximum aggregate size D<sub>max</sub>, cement type and class, chemical admixtures, the w/c ratio, and the National ZKP certificate number with a reference to the Construction Mark B.",
      q4: "What happens when the recipient tells the driver to add water on site?",
      a4: "In the fulfilment link or the app, the driver switches on “water added at the recipient's request” and enters the number of litres plus the name and role of the authorising person (e.g. the site manager). When signing, the recipient sees an unambiguous clause: adding water after batching without the designer's consent voids the producer's warranty for the declared strength class. The entry is clearly highlighted on the final POD; when no water was added, the document carries the formal statement “no water added on site — the mix conforms to the design”.",
      q5: "How do I prove the 90–120 minute limit from batching?",
      a5: "The e-WZ prints the batching / loading time at the plant. The driver then records the site arrival time and the start and end of unloading (the system suggests the current time). All the timestamps land on the POD, so in a complaint or expert assessment you have a record proving the mix was placed within the technological window.",
      q6: "What does the driver show during a roadside inspection or to the site manager?",
      a6: "Right from the road — without waiting for the recipient's signature — the driver has a large “Show e-WZ / SENT (PDF)” button in the fulfilment link and in the app. Today the document carries the complete EN 206 data and a preparatory-mode marker (concrete is not yet subject to SENT); once the rules take effect, the same document will show the SENT reference number and a QR code. It also works in PUESC outage mode as an emergency WZ consistent with the UD437 draft procedure.",
      q7: "Does a mixer truck need an OBU/ZSL locator or the SENT Monitor app?",
      a7: "Under the assumptions of draft bill UD437, ready-mix concrete transports by mixer trucks are to be exempt from the vehicle-location requirement. SENTBeton is configured without OBU/ZSL from the start. The draft is still in the legislative process — the final wording may change, and we will update the product to the published text.",
      q8: "What if the recipient is a private customer (B2C)?",
      a8: "The UD437 draft assumes a private customer does not have to confirm receipt in the SENT register — we collect the confirmation on the sender / plant side, as a digital signature on the recipient's or the driver's phone, together with a timestamp and the GPS coordinates of where it was signed.",
      q9: "How does signing work, and what about GDPR?",
      a9: "The recipient signs the record with a finger on the phone screen — no account needed. Before signing we display a GDPR information clause; the signature together with the date, time and geolocation lands on the POD document. We process the data in line with the <a href=\"/polityka-prywatnosci\">Privacy Policy</a>.",
      q10: "Can I plug in an ERP / batching-plant system?",
      a10: "Yes — the integrator API lets you create orders and dispatches from an external system, receive status webhooks and download WZ/POD documents. A test account and documentation are arranged at onboarding: <a href=\"mailto:kontakt@sentbeton.pl?subject=SENTBeton%20API\">kontakt@sentbeton.pl</a>.",
    },
    close: {
      h2: "Early adopters — the plant list",
      p: "We are looking for concrete plants that want to rehearse the e-WZ, driver links and the API before SENT on concrete becomes mandatory. No scare campaign about fines — concrete operational readiness. Write to us and we will add you to the list.",
    },
    footer: {
      copy: "© 2026 SENTBeton · a brand of HelpMeNow Prosta S.A.",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
    },
    cookie: {
      aria: "Cookie notice",
      text: "This site uses essential cookies and browser local storage (including to remember this notice). Details in the <a href=\"/polityka-prywatnosci\">Privacy Policy</a>.",
      btn: "Got it",
    },
  },
};
